import { ThemeProvider } from '@emotion/react';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import NotificationsIcon from '@mui/icons-material/NotificationsNoneOutlined';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { getOtherUserData } from 'APIs/UserDataApi';
import { useAppSelector } from 'app/hooks';
import SmallIconButton from 'components/atoms/Button/SmallIconButton';
import InboxLists from 'components/molecules/List/InboxLists';
// import Lists from 'components/molecules/List/Lists';
import { selectAuth } from 'features/auth/authSlice';
import { selectChat } from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';
import { useEffect, useState, useCallback } from 'react';
import Media from 'react-media';
import { useNavigate } from 'react-router-dom';
import ChatOptions from 'views/DesktopViews/DMessage/ChatOptions';
import {
  colortheme,
  CustomMenu,
  CustomMenuItem,
  NameText,
  NavLinkRow,
  NavLinkTypography,
  ParaText,
  ParaTextDivGrid,
  StyledBadge,
  UserInfoSection,
  UserSection,
} from './styles';

type Props = {
  data: any;
};

const DMessageHeader = ({ data }: Props) => {
  const history = useNavigate();
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const user = data ? (data.data as UserData) : undefined;
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const [following, setFollowing] = useState<any[]>();
  const [notificationMenuState, setNotificationMenuState] =
    useState<null | HTMLElement>(null);
  const [subscribers, setSubscribers] = useState<number[]>([]);

  const [messageMenuState, setMessageMenuState] = useState<null | HTMLElement>(
    null
  );

  const handleOpenNotificationMenu = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationMenuState(event.currentTarget);
  };

  const handleCloseNotificationMenu = () => {
    setNotificationMenuState(null);
  };

  const handleOpenMessageMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMessageMenuState(event.currentTarget);
  };

  const handleCloseMessageMenu = () => {
    setMessageMenuState(null);
  };

  const getSubscribers = useCallback(async () => {
    if (authState.name) {
      const userData = await getOtherUserData(authState.name);

      if (userData) {
        setSubscribers(userData.subscribers.map(e => e.from?.id));
      }
    } else return;
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    getSubscribers();
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    if (authState.following) {
      const authStateFollowing = authState.following.map(
        following => following.following.id
      );
      setFollowing(authStateFollowing);
    }
  }, [authState.id]); //eslint-disable-line

  return (
    <>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="fixed"
          color="primary"
          sx={{
            top: 0,
            padding: '2rem 1rem',
            // marginTop: "65px",
            // paddingBottom: "20px",
          }}
        >
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={6} style={{ display: 'flex', alignItems: 'center' }}>
              <div onClick={() => history('/message')}>
                <ArrowBackIos />
              </div>

              <UserSection>
                <img
                  src={user ? (user.avatar ? user.avatar : user0) : user0}
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    objectPosition: 'top',
                  }}
                  alt={'user'}
                  onClick={() => history('/profile/gallery')}
                />
                {user && (
                  <ChatOptions
                    user={user}
                    authState={authState}
                    senderId={user.id}
                  >
                    <UserInfoSection>
                      <NameText>{user && user.username}</NameText>
                      <SmallIconButton
                        type={'dev'}
                        isClicked={true}
                        color={'yellow'}
                        text={user ? user.role : 'client'}
                      />
                    </UserInfoSection>
                  </ChatOptions>
                )}
              </UserSection>
            </Grid>
            <Grid item xs={2}></Grid>

            <Media query="(max-width: 599px)">
              {matches =>
                matches ? (
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', justifyContent: 'end', gap: '30px' }}
                  >
                    <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="secondary"
                      sx={{ padding: 'unset' }}
                      onClick={() => history('/notification')}
                    >
                      <StyledBadge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        variant="dot"
                      >
                        <div>
                          <NotificationsIcon sx={{ fontSize: 'larger' }} />
                        </div>
                      </StyledBadge>
                    </IconButton>
                    <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="secondary"
                      sx={{ padding: 'unset' }}
                      onClick={() => history('/message')}
                    >
                      <div>
                        <NearMeOutlined
                          sx={{ fontSize: 'larger', color: '#ffffff' }}
                        />
                      </div>
                    </IconButton>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={4}
                    sx={{ display: 'flex', justifyContent: 'end', gap: '30px' }}
                  >
                    <NavLinkRow direction="row" spacing={2}>
                      <NavLinkTypography onClick={() => history('/')}>
                        Home
                      </NavLinkTypography>
                      <NavLinkTypography
                        onClick={() => history('/explore/otr')}
                      >
                        Explore
                      </NavLinkTypography>
                      <NavLinkTypography
                        onClick={() => history('/home/backstage')}
                      >
                        Backstage
                      </NavLinkTypography>
                      <NavLinkTypography
                        onClick={() => history('/home/rewards')}
                      >
                        Rewards
                      </NavLinkTypography>
                    </NavLinkRow>

                    <Box sx={{ flexGrow: 0, borderRadius: '15px' }}>
                      <IconButton
                        size="large"
                        aria-label="show 17 new notifications"
                        color="secondary"
                        sx={{ padding: 'unset' }}
                        onClick={handleOpenNotificationMenu}
                      >
                        <StyledBadge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          variant="dot"
                        >
                          <div>
                            <NotificationsIcon sx={{ fontSize: 'larger' }} />
                          </div>
                        </StyledBadge>
                      </IconButton>
                      <CustomMenu
                        sx={{ mt: '55px', position: 'absolute' }}
                        anchorEl={notificationMenuState}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={Boolean(notificationMenuState)}
                        onClose={handleCloseNotificationMenu}
                      >
                        <ParaTextDivGrid item xs={12}>
                          <ParaText>today</ParaText>
                        </ParaTextDivGrid>

                        {/* {[0, 1, 2].map((value, i) => (
                          <CustomMenuItem key={value}>
                            <Lists
                              key={i}
                              user={'@eliseeth22'}
                              time={'1h'}
                              image={'img' + value}
                              type={'first'}
                              message={' has liked your post'}
                            />
                          </CustomMenuItem>
                        ))} */}

                        <ParaTextDivGrid item xs={12}>
                          <ParaText>yesterday</ParaText>
                        </ParaTextDivGrid>

                        {/* {[0, 1, 2].map((value, i) => (
                          <CustomMenuItem key={value}>
                            <Lists
                              key={i}
                              user={'@remind'}
                              time={'1d'}
                              image={'img' + value}
                              type={'second'}
                              message={' has subscribed to your page 0.02 ETH.'}
                            />
                          </CustomMenuItem>
                        ))} */}
                      </CustomMenu>
                    </Box>

                    <Box sx={{ flexGrow: 0, borderRadius: '15px' }}>
                      <IconButton
                        size="large"
                        aria-label="show 17 new notifications"
                        color="secondary"
                        sx={{ padding: 'unset' }}
                        onClick={handleOpenMessageMenu}
                      >
                        <div>
                          <NearMeOutlined
                            sx={{ fontSize: 'larger', color: '#ffffff' }}
                          />
                        </div>
                      </IconButton>
                      <CustomMenu
                        sx={{ mt: '55px', position: 'absolute' }}
                        anchorEl={messageMenuState}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={Boolean(messageMenuState)}
                        onClose={handleCloseMessageMenu}
                      >
                        {chatState.inboxUsers
                          .filter(
                            inboxUser =>
                              !subscribers.includes(inboxUser.user.id) &&
                              ((following &&
                                following.includes(inboxUser.user.id)) ||
                                authState.generalChats.includes(
                                  inboxUser.user.id
                                ))
                          )
                          .map((user, i) => {
                            return (
                              <CustomMenuItem key={i}>
                                <InboxLists
                                  data={user.user}
                                  verified={user.user.verified}
                                />
                              </CustomMenuItem>
                            );
                          })}
                      </CustomMenu>
                    </Box>
                  </Grid>
                )
              }
            </Media>
          </Grid>
        </AppBar>
      </ThemeProvider>
    </>
  );
};

export default DMessageHeader;
